export class ApprovalNotice {
    Id: number;
    Name: number;
    BusinessId: number;
    RiskAnalysisId: number;
    ApprovedOn: Date;
    ApprovedBy: number;
    Status: string;
}